'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dCourse from "./mealorama.-Meal-Course.js";
var $p;
/** @constructor */
function $c_Lmealorama_MealCourse$other(name) {
  this.k0 = null;
  this.g6 = null;
  this.Ly = null;
  this.Ly = name;
  $j_mealorama$002e$002dMeal$002dCourse.$ct_Lmealorama_MealCourse__T__T__(this, name, name);
}
export { $c_Lmealorama_MealCourse$other as $c_Lmealorama_MealCourse$other };
$p = $c_Lmealorama_MealCourse$other.prototype = new $j_mealorama$002e$002dMeal$002dCourse.$h_Lmealorama_MealCourse();
$p.constructor = $c_Lmealorama_MealCourse$other;
/** @constructor */
function $h_Lmealorama_MealCourse$other() {
}
export { $h_Lmealorama_MealCourse$other as $h_Lmealorama_MealCourse$other };
$h_Lmealorama_MealCourse$other.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-759147471), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_MealCourse$other) && (this.Ly === x$0.Ly)));
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "other";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Ly;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
$p.hE = (function() {
  return this.Ly;
});
function $isArrayOf_Lmealorama_MealCourse$other(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jG)));
}
export { $isArrayOf_Lmealorama_MealCourse$other as $isArrayOf_Lmealorama_MealCourse$other };
var $d_Lmealorama_MealCourse$other = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealCourse$other, "mealorama.MealCourse$other", ({
  jG: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lmealorama_MealCourse$other as $d_Lmealorama_MealCourse$other };
//# sourceMappingURL=mealorama.-Meal-Course$other.js.map
